import { Helmet } from 'react-helmet-async';
import { Layout } from '@/components/layout/Layout';
import { EventCalendar } from '@/components/sections/EventCalendar';
import { useContactData } from '@/hooks/useContactData';
import { useNavigationData } from '@/hooks/useNavigationData';
import { useHomepageData } from '@/hooks/useHomepageData';
import { useSiteData } from '@/hooks/useSiteData';
import { downloadRSSFeed } from '@/utils/rss';
import { Rss } from 'lucide-react';

export function Events() {
  const { siteData } = useSiteData();
  const { contactInfo } = useContactData();
  const { navigationItems } = useNavigationData();
  const { pageData } = useHomepageData();

  const handleRSSDownload = () => {
    downloadRSSFeed(pageData.events, siteData.title, window.location.origin);
  };

  return (
    <>
      <Helmet>
        <title>Events & Calendar - {siteData.title}</title>
        <meta name="description" content="Stay up to date with Wayland Rod and Gun Club meetings, orientations, shooting events, and activities. View our complete event calendar." />
        <meta name="keywords" content="events, calendar, meetings, orientations, shooting events, Wayland Rod Gun Club" />
      </Helmet>

      <Layout contactInfo={contactInfo} navigationItems={navigationItems}>
        <div className="p-4 sm:p-8 space-y-6 sm:space-y-8 max-w-6xl mx-auto">
          <div className="text-center">
            <h1 className="text-4xl sm:text-5xl font-cursive text-primary-700 mb-4">
              Events
            </h1>
            <p className="text-lg text-neutral-600 max-w-2xl mx-auto leading-relaxed mb-6">
              Join us for regular meetings, orientations, and special shooting events throughout the year.
              All club activities are designed to promote safety, education, and fellowship among our members.
            </p>
            <div className="flex justify-center">
              <button
                onClick={handleRSSDownload}
                className="inline-flex items-center gap-2 px-4 py-2 bg-orange-600 hover:bg-orange-700 text-white font-medium rounded-lg transition-colors"
              >
                <Rss className="w-4 h-4" />
                Download RSS Feed
              </button>
            </div>
          </div>
          
          <EventCalendar events={pageData.events} />
        </div>
      </Layout>
    </>
  );
}